import { Component, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CustomTableComponent, CustomTitle, DataColumnType, FormGroupErrorMessageComponent, IButtonColumn, ICustomTable, IDataColumn, IHeader, LoadingPanelService, noWhitespaceValidator, Utils } from 'lib-base';
import { DialogModule } from 'primeng/dialog';
import { FileUpload, FileUploadHandlerEvent, FileUploadModule } from 'primeng/fileupload';
import { TablasDinamicasConfigService } from '../../../services/database/tablas-dinamicas-config.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { firstValueFrom, forkJoin } from 'rxjs';
import * as ExcelJS from 'exceljs';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { IColumnDinamico, ImportDatasetDto, TablasDinamicasConfig } from '../../../shared/interfaces/database/tramites_automaticos';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';
import { TabViewModule } from 'primeng/tabview';
import { DatasetDinamico } from './dataset-dinamico';
import { BaseColumn, ColumnType, ColumnTypeChecker, IForeingKey, NumberColumn, VisibleColumns } from './dataset-dinamico-columnas';
import { ConfiguracionLlavesComponent, LlavesOptions } from '../../../components/custom-work/other/configuracion-llaves/configuracion-llaves.component';

@Component({
  selector: 'app-form-dataset-creacion',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, DialogModule,
    CustomTitle, FileUploadModule, CustomTableComponent, FormGroupErrorMessageComponent,
    InputTextModule, DropdownModule, ButtonModule, TooltipModule,
    TranslateModule, PanelModule, CheckboxModule, TabViewModule,
    ConfiguracionLlavesComponent
  ],
  template: `
    <section>
      <form [formGroup]="importForm" (ngSubmit)="onSubmit()">
        <p-dialog [(visible)]="displayModal" [modal]="true" 
              [autoZIndex]="true" [draggable]="false" [resizable]="true" [maximizable]="true" 
              [breakpoints]="{'640px': '100vw'}" [style]="{width: '80vw'}">  
          <ng-template pTemplate="header">
            <CustomTitle [title]="formTitle" />
          </ng-template>
  
          <ng-template pTemplate="content"> 
            <div class="w-full pb-1">
              <p-panel [header]="'msg.configuracionTabla' | translate" 
                [toggleable]="false" [collapsed]="false">
                <div class="grid formgrid p-fluid">
                  <div class="field col-12" *ngIf="isNewForm">
                    <p-fileUpload #fileUpload mode="basic" accept=".xls,.xlsx,.csv" chooseStyleClass="p-button-sm"
                      chooseIcon="pi pi-upload" [chooseLabel]="trans.fileUploadChoose" [customUpload]="true" [auto]="true"
                      (uploadHandler)="uploadHandler($event, fileUpload)"></p-fileUpload>
                  </div>
                  <div class="field col-12">
                    <label class="ml-3" for="datasetNombre">{{trans.datasetNombre}}<span style="color: red">*</span></label>
                    <input pInputText formControlName="datasetNombre" id="datasetNombre" type="text" (input)="onDatasetNombreInput($event)">
                    <ng-container *ngIf="importForm.get('datasetNombre')?.invalid && importForm.get('datasetNombre')?.touched">
                        <app-form-group-error-message [control]="importForm.get('datasetNombre')"></app-form-group-error-message>
                    </ng-container>
                  </div>
                  <div class="field col-12 container-checkbox">
                    <label class="label-text block ml-3" for="permiteDocumentos">{{'common.permiteDocumentos' | translate}}</label>
                    <p-checkbox formControlName="permiteDocumentos" [binary]="true" inputId="permiteDocumentos"></p-checkbox>
                  </div>
                </div>    
              </p-panel>
            </div>              

            @if(datasetDinamico.columns.length > 0) { 
              <p-panel [header]="'msg.infoColumnasImportadas' | translate"
                [toggleable]="true" [collapsed]="false">
                <div class="grid col-12 p-fluid">
                  <p-tabView class="w-full" [(activeIndex)]="activeColumnIndex" [scrollable]="true">
                    @for (column of datasetDinamico.columns; track column; let idx = $index) {
                      <p-tabPanel [header]="column.name">
                        <div class="grid">
                          <div class="field col-4">
                            <label>{{'common.tipo' | translate}}</label>
                            <p-dropdown [id]="column.name + 'type'" [options]="visibleColumns" [(ngModel)]="column.type" [ngModelOptions]="{standalone: true}" 
                              optionLabel="text" optionValue="value"
                              appendTo="body"></p-dropdown>
                          </div> 
                          <div class="field col-4">
                            <label>{{'common.displayName' | translate}}</label>
                            <input pInputText [id]="column.name + 'displayName'" type="text" [(ngModel)]="column.displayName" [ngModelOptions]="{standalone: true}"/>
                          </div> 
                          @if(typeChecker.hasExcelColumn(column)) {
                            <div class="field col-4">
                              <label>{{'common.formato' | translate}}</label>
                              <input pInputText [id]="column.name + 'format'" type="text" [(ngModel)]="column.format" [ngModelOptions]="{standalone: true}"/>
                            </div>                           
                          }
                          @if(typeChecker.hasUnique(column)) {
                            <div class="field col-4 container-checkbox">
                              <label class="label-text block" [for]="column.name + 'isUnique'">{{'common.esUnico' | translate}}</label>
                              <p-checkbox [(ngModel)]="column.isUnique" [ngModelOptions]="{standalone: true}" [binary]="true" [inputId]="column.name + 'isUnique'"></p-checkbox>
                            </div>                           
                          }
                          @if(typeChecker.hasForeingKey(column)) {
                          <p-panel [header]="'msg.configuracionLlavesForaneas' | translate" 
                            [toggleable]="true" [collapsed]="true" class="w-full pt-1">
                            <div class="grid formgrid p-fluid">
                              <div class="field col-12">                                
                                <label for="tablaDinamica" class="ml-3">{{'common.tablaDinamica' | translate}}</label>
                                <div class="flex gap-1 justify-content-start">
                                  <p-dropdown [options]="tablasDinamicasConfig" appendTo="body"
                                    [(ngModel)]="column.llaveForaneaTablaId" [ngModelOptions]="{standalone: true}"
                                    optionLabel="datasetNombre" optionValue="id" [placeholder]="'common.seleccionar'| translate"
                                    autoWidth="false" class="flex-grow-1" [filter]="true" [showClear]="true"
                                    (onChange)="onTablaParaActualizacionChange($event, column.name)"
                                    (onClear)="onTablaParaActualizacionClear(column.name)">
                                  </p-dropdown> 
                                </div>
                              </div>
                              <div class="field col-12">
                                <label for="columnaParaVisualizar" class="ml-3">{{'msg.columnaParaVisualizar' | translate}}</label>
                                <div class="flex gap-1 justify-content-start">
                                  <p-dropdown [options]="getTablasDinamicaSeleccionadaColumnas(column.name)" appendTo="body"
                                    [(ngModel)]="column.llaveForaneaColumnaVisible" [ngModelOptions]="{standalone: true}"
                                    optionLabel="displayName" optionValue="name" [placeholder]="'common.seleccionar'| translate"
                                    autoWidth="false" class="flex-grow-1" [filter]="true" [showClear]="true">
                                  </p-dropdown> 
                                </div>
                              </div>
                              <div class="field col-12 md:col-12">
                                <app-configuracion-llaves #TablaLlavesForeaneas
                                  [showDelete]="true" [showAdd]="true" [id]="column.name"
                                  [headerTitle]="'msg.mapeoDeLlavesForaneas' | translate">
                                </app-configuracion-llaves>
                              </div>
                            </div>
                          </p-panel>
                          }
                        </div>
                      </p-tabPanel>
                    }
                  </p-tabView>
                </div>           
                <div class="col-12 flex flex-wrap gap-1" >
                  <button pButton type="button" *ngIf="isNewForm" 
                    [label]="'form.button.actualizar' | translate" 
                    icon="pi pi-refresh" 
                    class="p-button-success flex-grow-1" 
                    (click)="updateImportedColumns()">
                  </button>
                  <button pButton type="button" [label]="'common.agregar' | translate" 
                    icon="pi pi-plus" 
                    class="p-button-primary flex-grow-1" 
                    (click)="openAddColumnModal()">
                  </button>
                </div>
              </p-panel>

              <custom-table [config]="importTable" *ngIf="isNewForm">
              </custom-table>		
            }
          </ng-template>

          <ng-template pTemplate="footer">
            <div class="field col-12">
              <div class="flex justify-content-between">
                <button pButton type="button" [label]="trans.cancelar" class="tax-app-button " (click)="closeModal()"></button>
                <button pButton type="submit" [label]="trans.aplicar" icon="pi pi-save" class="tax-app-button "></button>
              </div>
            </div>
          </ng-template>
        </p-dialog>
      </form>      
    </section>

    <form [formGroup]="addColumnForm" (ngSubmit)="onSubmitAddColumn()">
      <p-dialog [(visible)]="addColumnVisible" 
        [breakpoints]="{'640px': '100vw'}" [style]="{ width: '30rem' }"
        [autoZIndex]="true" [draggable]="false" [resizable]="true" [maximizable]="true" >
        <ng-template pTemplate="header">
          <CustomTitle [title]="'Agregar Columna'" />
        </ng-template>
        <ng-template pTemplate="content">
          <div class="grid col-12 p-fluid">
            <div class="field col-12">
              <label>{{'common.columnName' | translate}}</label>
              <input pInputText type="text" formControlName="columnName"/>
              <ng-container *ngIf="addColumnForm.get('columnName')?.invalid && addColumnForm.get('columnName')?.touched">
                  <app-form-group-error-message [control]="addColumnForm.get('columnName')"></app-form-group-error-message>
              </ng-container>
            </div> 
          </div>
        </ng-template>
        <ng-template pTemplate="footer">
          <div class="field col-12">
            <div class="flex justify-content-between">
              <button pButton type="button" [label]="trans.cancelar" class="tax-app-button " (click)="addColumnVisible = false"></button>
              <button pButton type="submit" [label]="trans.aplicar" icon="pi pi-save" class="tax-app-button "></button>
            </div>
          </div>
        </ng-template>
      </p-dialog>
    </form>
  `,
})
export class FormDatasetCreacionComponent implements OnInit {
  formTitle: string = "Nuevo";
  displayModal = false;
  trans: any = {};
  importForm !: FormGroup;
  _editData !: TablasDinamicasConfig | undefined;

  datasetDinamico !: DatasetDinamico;
  typeChecker = ColumnTypeChecker;
  visibleColumns: any[] = VisibleColumns;

  importTable !: ICustomTable;
  @ViewChild(CustomTableComponent) importTableComponent !: CustomTableComponent;
  @Output() onClose = new EventEmitter<void>();

  columnTypeOptions = [
    { label: 'Texto', value: ExcelJS.ValueType.String },
    { label: 'Número', value: ExcelJS.ValueType.Number },
    { label: 'Fecha', value: ExcelJS.ValueType.Date },
    { label: 'Booleano', value: ExcelJS.ValueType.Boolean }
  ];

  get isNewForm(): boolean {
    return this._editData === undefined;
  }

  activeColumnIndex: number = 0;
  //Add column
  addColumnVisible: boolean = false;
  addColumnForm !: FormGroup;

  //Foreing key
  tablasDinamicasConfig!: TablasDinamicasConfig[];  
  tablasDinamicasConfigReady: boolean = false;
  _tablasDinamicaSeleccionadaColumnas: Map<String, IColumnDinamico[]> = new Map();
  getTablasDinamicaSeleccionadaColumnas(columnName: string): IColumnDinamico[] {
    return this._tablasDinamicaSeleccionadaColumnas.get(columnName) || [];
  }
  @ViewChildren('TablaLlavesForeaneas', { read: ConfiguracionLlavesComponent }) tablaLlavesForeaneas!: QueryList<ConfiguracionLlavesComponent>;

  constructor(private readonly _tsc: TablasDinamicasConfigService, private readonly _t: TranslateService,
    private readonly _ms: MessageService, private readonly _fb: FormBuilder, private readonly _lps: LoadingPanelService,
    private _tdcs: TablasDinamicasConfigService) {
  }

  ngOnInit(): void {
    this.translate().then(() => {
      this.datasetDinamico = new DatasetDinamico({
        translations: this.trans,
        translateService: this._t
      });
    });
    this.configureForm();
    this.configureAddColumnForm();
    this.getTablasDinamicas();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      nuevoDataset: this._t.get('msg.nuevoDataset'),
      fileUploadChoose: this._t.get('form.button.fileUpload-choose'),
      datasetNombre: this._t.get('common.datasetNombre'),
      cancelar: this._t.get('form.button.cancelar'),
      aplicar: this._t.get('form.button.aplicar'),
      encabezadosUnicos: this._t.get('msg.encabezadosUnicos'),
      infoLoadedSuccessfully: this._t.get('msg.infoLoadedSuccessfully'),
      columnsUpdatedSuccessfully: this._t.get('msg.columnsUpdatedSuccessfully'),
      datasetCreatedSuccessfully: this._t.get('msg.datasetCreatedSuccessfully'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      success: this._t.get('common.success'),
      editarDataset: this._t.get('msg.editarDataset'),
      insufficientData: this._t.get('msg.insufficientData'),
      yaExisteUnaColumnaConEseNombre: this._t.get('msg.yaExisteUnaColumnaConEseNombre'),
      columnasTablaDinamica: this._t.get('common.columnasTablaDinamica'),
      columnasTablaDinamicaSeleccionadas: this._t.get('common.columnasTablaDinamicaSeleccionadas'),
    }));
  }

  //#region Form
  get formDatasetNombre(): string {
    return this.importForm.get('datasetNombre')?.value;
  }

  set formDatasetNombre(value: string) {
    this.importForm.patchValue({ datasetNombre: value });
  }

  get formPermiteDocumentos(): boolean {
    return this.importForm.get('permiteDocumentos')?.value;
  }

  set formPermiteDocumentos(value: boolean) {
    this.importForm.patchValue({ permiteDocumentos: value });
  }

  private configureForm(): void {
    this.importForm = this._fb.group({
      datasetNombre: ['', [
        Validators.required,
        noWhitespaceValidator,
        Validators.maxLength(63),
        Validators.pattern(DatasetDinamico.POSTGRES_COLUMN_NAME_REGEX)
      ]],
      permiteDocumentos: [false, [Validators.required]]
    });
  }

  open() {
    this.formTitle = this.trans.nuevoDataset;
    this._editData = undefined;
    this.displayModal = true;
    this.importForm.reset();
    this.importTable = {} as ICustomTable;
    this.importForm.get('datasetNombre')?.enable();
    this.formPermiteDocumentos = false;
  }

  openEdit(data: TablasDinamicasConfig) {
    this.formTitle = this.trans.editarDataset;
    this.importForm.reset();
    this._editData = data;
    this.displayModal = true;

    this.datasetDinamico.loadColumns(data.datasetColumnas);

    this.formDatasetNombre = this._editData.datasetNombre;
    this.importForm.get('datasetNombre')?.disable();
    this.formPermiteDocumentos = this._editData.permiteDocumentos;
    this.tryToLoadSavedData();
  }

  closeModal() {
    this.displayModal = false;
    this.onClose.emit();
  }

  onDatasetNombreInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let filtered = '';
    for (const char of input.value) {
      if (DatasetDinamico.POSTGRES_COLUMN_NAME_REGEX.test(char)) {
        filtered += char;
      }
    }
    if (input.value !== filtered) {
      input.value = filtered;
      this.formDatasetNombre = filtered;
    }
  }
  //#endregion Form

  //#region Import
  uploadHandler(event: FileUploadHandlerEvent, fileUpload: FileUpload) {
    const file = event.files[0];
    const fileReader = new FileReader();
    const fileName = file.name.toLowerCase();

    fileReader.onload = (e: any) => {
      const result = e.target.result;
      let parserPromise;
      if (fileName.endsWith('.csv')) {
        const csvText = new TextDecoder().decode(new Uint8Array(result));
        parserPromise = this.datasetDinamico.parseCsv(csvText);
      } else {
        parserPromise = this.datasetDinamico.parseExcel(result);
      }

      parserPromise.then(args => {
        if (args.valid) {
          this.loadImportTable();
          this._ms.add({ severity: 'success', summary: 'Success', detail: this.trans.infoLoadedSuccessfully });
        } else {
          this._ms.add({ severity: 'error', summary: 'Error', detail: args.msg });
        }
      });
    };

    fileReader.readAsArrayBuffer(file);
    fileUpload.clear();
  }
  //#endregion Import

  //#region Add Column
  configureAddColumnForm() {
    this.addColumnForm = this._fb.group({
      columnName: ['', [Validators.required, noWhitespaceValidator, Validators.maxLength(63), Validators.pattern(DatasetDinamico.POSTGRES_COLUMN_NAME_REGEX)]],
    });
  }

  openAddColumnModal() {
    this.addColumnForm.reset();
    this.addColumnVisible = true;
  }

  onSubmitAddColumn() {
    if (this.addColumnForm.invalid) {
      Utils.markAllFormControlsAsTouched(this.addColumnForm);
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
      return;
    }

    const name = this.addColumnForm.get('columnName')?.value.trim().toLowerCase();

    if (this.datasetDinamico.columns.find(col => col.name.trim().toLowerCase() === name)) {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.yaExisteUnaColumnaConEseNombre });
      return;
    }

    const data = {
      name: name,
      displayName: name,
      format: '',
      editable: true
    }
    this.datasetDinamico.addNewColumn(ColumnType.String, data);

    setTimeout(() => {
      this.activeColumnIndex = this.datasetDinamico.columns.length - 1;
    }, 1);
    this.addColumnVisible = false;
  }
  //#endregion Add Column

  //#region foreign key
  private getTablasDinamicas() {
    this._tdcs.getTablasDinamicas().subscribe({
      next: (data: TablasDinamicasConfig[]) => {
        const idColumns = {
          name: "id",
          type: ColumnType.Number,
          displayName: "ID"
        } as IColumnDinamico;
        data.forEach(item => {
          item.datasetColumnas.push(idColumns);
        });
        this.tablasDinamicasConfig = data;
        this.tablasDinamicasConfigReady = true
      }
    });
  }

  onTablaParaActualizacionClear(columnName: string) {
    const component = this.tablaLlavesForeaneas.find(c => c.id === columnName);
    if (component) {
      component.reset();
    }
  }

  onTablaParaActualizacionChange(event: DropdownChangeEvent, columnName: string) {
    const value = event.value;
    if (!value) return;
    const component = this.tablaLlavesForeaneas.find(c => c.id === columnName);
    if (component) {
      this.initializeTablaParaLlavesForaneas(component, value, columnName, false);
      const selectedTabla = this.tablasDinamicasConfig.find(t => t.id === value);
      if (!selectedTabla) return;
      const selectedTablaColumns: IColumnDinamico[] = selectedTabla.datasetColumnas ?? [];
      this._tablasDinamicaSeleccionadaColumnas.set(columnName, selectedTablaColumns);
    }
  }

  private initializeTablaParaLlavesForaneas(component: ConfiguracionLlavesComponent, tablaId: number, columnName: string, reset: boolean = true) {
    if (!component) {
      return;
    }

    if (reset) {
      component.reset();
    }
    const selectedTabla = this.tablasDinamicasConfig.find(t => t.id === tablaId);
    if (!selectedTabla) return;

    // Parse the tabla dinamica columns from JSON string
    const selectedTablaColumns: IColumnDinamico[] = selectedTabla.datasetColumnas ?? [];

    // Get the specific form controls for this formularioControles item    
    let tablaColumns: BaseColumn<any>[] = this.datasetDinamico.columns ? [...this.datasetDinamico.columns] : [];

    const keys = {
      data: selectedTablaColumns,
      optionLabel: 'displayName',
      optionValue: 'name',
      headerText: this.trans.columnasTablaDinamicaSeleccionadas
    } as LlavesOptions;

    const values = {
      data: tablaColumns,
      optionLabel: 'displayName',
      optionValue: 'name',
      headerText: this.trans.columnasTablaDinamica
    } as LlavesOptions;

    component.loadOptions(keys, values);
  }

  private tryToLoadSavedData() {
    if (!this.tablasDinamicasConfigReady) return;
    setTimeout(() => {
      this.datasetDinamico.columns.forEach(column => {
        if (!this.typeChecker.hasForeingKey(column))
          return;
        this._tablasDinamicaSeleccionadaColumnas.set(column.name, this.tablasDinamicasConfig.find(t => t.id === column.llaveForaneaTablaId)?.datasetColumnas || []);
        
        const component = this.tablaLlavesForeaneas.find(c => c.id === column.name);
        if (!component) return;
        
        this.initializeTablaParaLlavesForaneas(component, column.llaveForaneaTablaId, column.name, true);
        if(!column.llavesForaneas) return;
        component.llaves = column.llavesForaneas;
        column.llaveForaneaColumnaVisible = column.llaveForaneaColumnaVisible; 

      });
    });
    
  }
  //#endregion foreign key

  updateImportedColumns() {
    this.loadImportTable();

    this._ms.add({ severity: 'success', summary: this.trans.success, detail: this.trans.columnsUpdatedSuccessfully });
  }

  loadImportTable() {
    let columnsTable: (IDataColumn | IButtonColumn<any>)[] = [];
    this.datasetDinamico.columns.forEach(column => {
      columnsTable.push({
        field: column.name,
        header: column.displayName,
        class: 'font-13 ' + column.getColumnAlignment(),
        columnmHeader: {
          class: 'color-blue-2 font-13 font-bold text-left',
        },
        dataType: DataColumnType.CUSTOM,
        format: ColumnTypeChecker.hasExcelColumn(column) ? column.format : ''
      });
    });

    this.importTable = {
      header: {
      } as IHeader,
      columns: columnsTable,
      settings: {
        table: {
          rows: 10,
        }
      }
    } as ICustomTable;

    //La informacion de la tabla se tiene que actualizar antes cargar el data
    setTimeout(() => {
      this.importTableComponent.data = this.datasetDinamico.data;
    }, 1);
  }

  private importarDataset(importDatasetDto: ImportDatasetDto) {
    this._lps.show(true);
    this._tsc.importarDataset(importDatasetDto).subscribe({
      next: (message) => {
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: this.trans.datasetCreatedSuccessfully });
        this.closeModal();
        this._lps.hide();
      }
    });
  }

  private editarDataset(importDatasetDto: ImportDatasetDto) {
    this._lps.show(true);
    this._tsc.editarDataset(this._editData!.id, importDatasetDto, this.datasetDinamico.newColumns).subscribe({
      next: (message) => {
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: this.trans.datasetCreatedSuccessfully });
        this.closeModal();
        this._lps.hide();
      }
    });
  }

  onSubmit() {
    if (this.importForm.invalid) {
      Utils.markAllFormControlsAsTouched(this.importForm);
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
      return;
    }

    //obtener la configuracion de llaves foraneas
    this.datasetDinamico.columns.forEach(column => {
      if (!this.typeChecker.hasForeingKey(column))
        return;
      const component = this.tablaLlavesForeaneas.find(c => c.id === column.name);
      if (component) {
        column.llavesForaneas = component.getValues() || [];
      }
    });

    const importDatasetDto: ImportDatasetDto = {
      datasetNombre: this.formDatasetNombre,
      importedColumns: this.datasetDinamico.toJSON(),
      importedData: this.isNewForm ? this.datasetDinamico.data : [],
      permiteDocumentos: this.formPermiteDocumentos
    };
    if (this.isNewForm) {
      if (this.datasetDinamico.data.length === 0) {
        this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.insufficientData });
        return;
      }
      this.importarDataset(importDatasetDto);
    } else {
      this.editarDataset(importDatasetDto);
    }
  }
}
